import { isNode } from "react-flow-renderer";
import { isEdge } from "react-flow-renderer";

export const getOutScopedElements = (elements) =>
  elements ? elements.filter((item) => item.data.status === "outscoped") : [];

export const getMarkers = (elements) =>
  elements ? elements.filter((item) => item.type === "customMark") : [];

export const getCustomNotes = (elements) =>
  elements ? elements.filter((item) => item.type === "customNote") : [];

export const getVisibleElements = (elements, options) => {
  const { markers: markersVisible, outscoped: outscopedVisible } = options;

  return elements.map((item) => {
    if (
      (item.data.status === "outscoped" && !outscopedVisible) ||
      (item.type === "customMark" && !markersVisible)
    ) {
      return { ...item, isHidden: true };
    } else {
      return {
        ...item,
        isHidden: false,
        className:
          item.type === "customMark" ||
          item.type === "customText" ||
          item.type === "customEdge" ||
          item.type === "customEdgeWithoutLabel"
            ? "non-interactable"
            : null,
      };
    }
  });
};

const sortEdges = (edges) => {
  return edges.sort((a, b) => {
    if (a.data.status === "done" && b.data.status === "pending") {
      return 1;
    } else if (a.data.status === "pending" && b.data.status === "done") {
      return -1;
    } else {
      return 0;
    }
  });
};

const sortNodes = (nodes) => {
  const isCustomMarkExist = nodes.filter((item) => item.type === "customMark");

  if (isCustomMarkExist.length > 0) {
    const filterElements = nodes.filter((item) => item.type !== "customMark");

    return [
      ...isCustomMarkExist,
      ...filterElements.sort((a, b) => {
        if (a.type === "timerEvent" && b.type !== "timerEvent") return 1;
        if (a.type !== "timerEvent" && b.type === "timerEvent") return -1;
        return 0;
      }),
    ];
  }

  return nodes.sort((a, b) => {
    if (a.type === "timerEvent" && b.type !== "timerEvent") return 1;
    if (a.type !== "timerEvent" && b.type === "timerEvent") return -1;
    if (a.type === "customNote") return 1;
    if (b.type === "customNote") return -1;
    return 0;
  });
};

export const getElements = (state) => {
  const flow = state.activedFlows.pane.flow;

  if (!flow.elements) return [];

  const elements = flow.elements;

  const nodes = elements.filter((item) => isNode(item));
  const edges = elements.filter((item) => isEdge(item));

  const sortedNodes = sortNodes(nodes);
  const sortedEdges = sortEdges(edges);

  return [...sortedNodes, ...sortedEdges];
};

export const getNodeById = (state, id) => {
  const elements = state.activedFlows.pane.flow.elements;

  if (!elements) {
    return;
  }
  return elements.find((item) => item.id === id);
};

export const getEdgeByNodeId = (state, nodeId) => {
  const elements = state.activedFlows.pane.flow.elements;

  if (!elements) {
    return;
  }

  return elements.find((item) => item.source === nodeId);
};
